webpackJsonp([18],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0CPG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swipebox_css__ = __webpack_require__("Rd/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swipebox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__swipebox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style5_css__ = __webpack_require__("Zsl5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style5_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style5_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_css__ = __webpack_require__("GUTX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_ui_select_dist_select_css__ = __webpack_require__("I37r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_ui_select_dist_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_ui_select_dist_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themestyle_css__ = __webpack_require__("hK/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themestyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__themestyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chocolat_css__ = __webpack_require__("vfl4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chocolat_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__chocolat_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flexslider_css__ = __webpack_require__("hG4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flexslider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flexslider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_css__ = __webpack_require__("RYnZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__app_css__);
// <!-- theme dependencies -->





// <!-- theme css -->




// own css



/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5MmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ID_TOKEN_KEY = 'id_token';

/* harmony default export */ __webpack_exports__["a"] = ({
  getToken: function getToken() {
    return window.localStorage.getItem(ID_TOKEN_KEY);
  },
  saveToken: function saveToken(token) {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
  },
  destroyToken: function destroyToken() {
    window.localStorage.removeItem(ID_TOKEN_KEY);
  }
});

/***/ }),

/***/ "5bni":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9J7/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_config__ = __webpack_require__("wYMm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "RwvHeader",
  data: function data() {
    return {
      uMenuIsOpen: false,
      navBar: false,
      writerRoles: ["author", "admin"],
      mainGroupId: __WEBPACK_IMPORTED_MODULE_1__common_config__["a" /* mainGroupId */]
    };
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(["currentUser", "isAuthenticated"])),
  methods: {
    /**
     * check for valid role for group
     */
    checkGroupRole: function checkGroupRole(usergroups, groupid, roleNames) {
      if (usergroups) {
        var groupIndex = usergroups.findIndex(function (x) {
          return x.group_id === groupid;
        });
        if (groupIndex !== -1) {
          var usergroup = usergroups[groupIndex];
          return usergroup.roles.findIndex(function (x) {
            return roleNames.indexOf(x.name) !== 1;
          }) !== 1;
        }
      }
      return false;
    }
  }
});

/***/ }),

/***/ "AezD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PURGE_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_COMMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TAG_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TAG_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_ARTICLE_IN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_STATE; });
var FETCH_END = 'setArticles';
var FETCH_START = 'setLoading';
var PURGE_AUTH = 'logOut';
var SET_ARTICLE = 'setArticle';
var SET_AUTH = 'setUser';
var SET_COMMENTS = 'setComments';
var SET_ERROR = 'setError';
var SET_PROFILE = 'setProfile';
var SET_TAGS = 'setTags';
var TAG_ADD = 'addTag';
var TAG_REMOVE = 'removeTag';
var UPDATE_ARTICLE_IN_LIST = 'updateAricleInList';
var RESET_STATE = 'resetModuleState';

/***/ }),

/***/ "BVEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__ = __webpack_require__("9J7/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bde0872_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__ = __webpack_require__("uePh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bde0872_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bde0872_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D39R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export actions */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_type__ = __webpack_require__("AezD");
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var initialState = {
  article: {
    author: {},
    title: "",
    description: "",
    body: "",
    tagList: []
  },
  comments: []
};

var state = Object.assign({}, initialState);

var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["e" /* FETCH_ARTICLE */], function (context, articleSlug, prevArticle) {
  // avoid extronuous network call if article exists
  if (prevArticle !== undefined) {
    return context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], prevArticle);
  }
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["b" /* ArticlesService */].get(articleSlug).then(function (_ref) {
    var data = _ref.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], data.article);
    return data;
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["f" /* FETCH_COMMENTS */], function (context, articleSlug) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["c" /* CommentsService */].get(articleSlug).then(function (_ref2) {
    var data = _ref2.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["c" /* SET_COMMENTS */], data.comments);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["g" /* COMMENT_CREATE */], function (context, payload) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["c" /* CommentsService */].post(payload.slug, payload.comment).then(function () {
    context.dispatch(__WEBPACK_IMPORTED_MODULE_2__actions_type__["f" /* FETCH_COMMENTS */], payload.slug);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["h" /* COMMENT_DESTROY */], function (context, payload) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["c" /* CommentsService */].destroy(payload.slug, payload.commentId).then(function () {
    context.dispatch(__WEBPACK_IMPORTED_MODULE_2__actions_type__["f" /* FETCH_COMMENTS */], payload.slug);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["i" /* FAVORITE_ADD */], function (context, payload) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["d" /* FavoriteService */].add(payload).then(function (_ref3) {
    var data = _ref3.data;

    // Update list as well. This allows us to favorite an article in the Home view.
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["d" /* UPDATE_ARTICLE_IN_LIST */], data.article, { root: true });
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], data.article);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["j" /* FAVORITE_REMOVE */], function (context, payload) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["d" /* FavoriteService */].remove(payload).then(function (_ref4) {
    var data = _ref4.data;

    // Update list as well. This allows us to favorite an article in the Home view.
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["d" /* UPDATE_ARTICLE_IN_LIST */], data.article, { root: true });
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], data.article);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["k" /* ARTICLE_PUBLISH */], function (_ref5) {
  var state = _ref5.state;

  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["b" /* ArticlesService */].create(state.article);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["l" /* CHECK_DOMAIN */], function (context, payload) {
  console.log("module layer:");
  console.log(context);
  console.log(payload);
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["e" /* BillingService */].checkDomain(payload);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["m" /* BILLING */], function (_ref6) {
  var state = _ref6.state;

  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["e" /* BillingService */].billGroup(state.billing);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["n" /* ARTICLE_DELETE */], function (context, slug) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["b" /* ArticlesService */].destroy(slug);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["o" /* ARTICLE_EDIT */], function (_ref7) {
  var state = _ref7.state;

  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["b" /* ArticlesService */].update(state.article.slug, state.article);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["p" /* ARTICLE_EDIT_ADD_TAG */], function (context, tag) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["e" /* TAG_ADD */], tag);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["q" /* ARTICLE_EDIT_REMOVE_TAG */], function (context, tag) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["f" /* TAG_REMOVE */], tag);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["r" /* ARTICLE_RESET_STATE */], function (_ref8) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["g" /* RESET_STATE */]);
}), _actions);

/* eslint no-param-reassign: ["error", { "props": false }] */
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], function (state, article) {
  state.article = article;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["c" /* SET_COMMENTS */], function (state, comments) {
  state.comments = comments;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["e" /* TAG_ADD */], function (state, tag) {
  state.article.tagList = state.article.tagList.concat([tag]);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["f" /* TAG_REMOVE */], function (state, tag) {
  state.article.tagList = state.article.tagList.filter(function (t) {
    return t !== tag;
  });
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["g" /* RESET_STATE */], function () {
  for (var f in state) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, f, initialState[f]);
  }
}), _mutations);

var getters = {
  domain: function domain(state) {
    return state.domain;
  },
  group: function group(state) {
    return state.group;
  },
  billing: function billing(state) {
    return state.billing;
  },
  article: function article(state) {
    return state.article;
  },
  comments: function comments(state) {
    return state.comments;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "GTdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__("Eoz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);


/* harmony default export */ __webpack_exports__["a"] = (function (date) {
  return __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(new Date(date), 'MMMM D, YYYY');
});

/***/ }),

/***/ "GUTX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GfHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GyQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__ = __webpack_require__("UVMV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ed6f4f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__ = __webpack_require__("zLDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ed6f4f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ed6f4f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I37r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_module__ = __webpack_require__("Kits");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_module__ = __webpack_require__("itPX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__article_module__ = __webpack_require__("D39R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_module__ = __webpack_require__("IyCy");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: {
    home: __WEBPACK_IMPORTED_MODULE_2__home_module__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_3__auth_module__["a" /* default */],
    article: __WEBPACK_IMPORTED_MODULE_4__article_module__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_5__profile_module__["a" /* default */]
  }
}));

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IyCy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_type__ = __webpack_require__("AezD");
var _actions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var state = {
  errors: {},
  profile: {}
};

var getters = {
  profile: function profile(state) {
    return state.profile;
  }
};

var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["b" /* FETCH_PROFILE */], function (context, payload) {
  var username = payload.username;

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].get('profiles', username).then(function (_ref) {
    var data = _ref.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["a" /* SET_PROFILE */], data.profile);
    return data;
  }).catch(function (_ref2) {
    // #todo SET_ERROR cannot work in multiple states
    // context.commit(SET_ERROR, response.data.errors)

    var response = _ref2.response;
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["c" /* FETCH_PROFILE_FOLLOW */], function (context, payload) {
  var username = payload.username;

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].post('profiles/' + username + '/follow').then(function (_ref3) {
    var data = _ref3.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["a" /* SET_PROFILE */], data.profile);
    return data;
  }).catch(function (_ref4) {
    // #todo SET_ERROR cannot work in multiple states
    // context.commit(SET_ERROR, response.data.errors)

    var response = _ref4.response;
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["d" /* FETCH_PROFILE_UNFOLLOW */], function (context, payload) {
  var username = payload.username;

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].delete('profiles/' + username + '/follow').then(function (_ref5) {
    var data = _ref5.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["a" /* SET_PROFILE */], data.profile);
    return data;
  }).catch(function (_ref6) {
    // #todo SET_ERROR cannot work in multiple states
    // context.commit(SET_ERROR, response.data.errors)

    var response = _ref6.response;
  });
}), _actions);

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["a" /* SET_PROFILE */], function (state, profile) {
  state.profile = profile;
  state.errors = {};
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "Kits":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_type__ = __webpack_require__("AezD");
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var state = {
  tags: [],
  articles: [],
  isLoading: true,
  articlesCount: 0
};

var getters = {
  articlesCount: function articlesCount(state) {
    return state.articlesCount;
  },
  articles: function articles(state) {
    return state.articles;
  },
  isLoading: function isLoading(state) {
    return state.isLoading;
  },
  tags: function tags(state) {
    return state.tags;
  }
};

var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["w" /* FETCH_ARTICLES */], function (_ref, params) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["k" /* FETCH_START */]);
  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["b" /* ArticlesService */].query(params.type, params.filters).then(function (_ref2) {
    var data = _ref2.data;

    console.log("articles retrieved");
    data.articles = data.data;
    data.articlesCount = data.data.length;
    console.log(data);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["l" /* FETCH_END */], data);
  }).catch(function (error) {
    throw new Error(error);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["x" /* FETCH_TAGS */], function (_ref3) {
  var commit = _ref3.commit;

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["f" /* TagsService */].get().then(function (_ref4) {
    var data = _ref4.data;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["m" /* SET_TAGS */], data.tags);
  }).catch(function (error) {
    throw new Error(error);
  });
}), _actions);

/* eslint no-param-reassign: ["error", { "props": false }] */
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["k" /* FETCH_START */], function (state) {
  state.isLoading = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["l" /* FETCH_END */], function (state, _ref5) {
  var articles = _ref5.articles,
      articlesCount = _ref5.articlesCount;

  state.articles = articles;
  state.articlesCount = articlesCount;
  state.isLoading = false;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["m" /* SET_TAGS */], function (state, tags) {
  state.tags = tags;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["d" /* UPDATE_ARTICLE_IN_LIST */], function (state, data) {
  state.articles = state.articles.map(function (article) {
    if (article.slug !== data.slug) {
      return article;
    }
    // We could just return data, but it seems dangerous to
    // mix the results of different api calls, so we
    // protect ourselves by copying the information.
    article.favorited = data.favorited;
    article.favoritesCount = data.favoritesCount;
    return article;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "LguZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TagsService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BillingService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArticlesService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CommentsService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FavoriteService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_jwt_service__ = __webpack_require__("5MmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_config__ = __webpack_require__("wYMm");






var ApiService = {
  init: function init() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_4__common_config__["b" /* API_URL */];
  },
  setHeader: function setHeader() {
    /* eslint-disable */
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.defaults.headers.common["Authorization"] = "Token " + __WEBPACK_IMPORTED_MODULE_3__common_jwt_service__["a" /* default */].getToken();
    /* eslint-enable */
  },
  query: function query(resource, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(resource, params).catch(function (error) {
      throw new Error("[RWV] ApiService " + error);
    });
  },
  get: function get(resource) {
    var slug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    return slug ? __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(resource + "/" + slug).catch(function (error) {
      throw new Error("[RWV] ApiService " + error);
    }) : __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get("" + resource).catch(function (error) {
      throw new Error("[RWV] ApiService " + error);
    });
  },
  getName: function getName(resource) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get("" + resource).catch(function (error) {
      return error.response;
    });
  },
  post: function post(resource, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post("" + resource, params);
  },
  update: function update(resource, slug, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(resource + "/" + slug, params);
  },
  put: function put(resource, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put("" + resource, params);
  },
  delete: function _delete(resource) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(resource).catch(function (error) {
      throw new Error("[RWV] ApiService " + error);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ApiService);

var TagsService = {
  get: function get() {
    return ApiService.get("tags");
  }
};

var BillingService = {
  checkDomain: function checkDomain(domainName) {
    return ApiService.getName("domains/" + domainName);
  },
  billGroup: function billGroup(params) {
    return ApiService.post("subscriptions", params);
  }
};

var ArticlesService = {
  query: function query(type, params) {
    return ApiService.query("articles" + (type === "feed" ? "/feed" : ""), {
      params: params
    });
  },
  get: function get(slug) {
    return ApiService.get("articles", slug);
  },
  create: function create(params) {
    return ApiService.post("articles", { article: params });
  },
  update: function update(slug, params) {
    return ApiService.update("articles", slug, { article: params });
  },
  destroy: function destroy(slug) {
    return ApiService.delete("articles/" + slug);
  }
};

var CommentsService = {
  get: function get(slug) {
    if (typeof slug !== "string") {
      throw new Error("[RWV] CommentsService.get() article slug required to fetch comments");
    }
    return ApiService.get("articles", slug + "/comments");
  },
  post: function post(slug, payload) {
    return ApiService.post("articles/" + slug + "/comments", {
      comment: { body: payload }
    });
  },
  destroy: function destroy(slug, commentId) {
    return ApiService.delete("articles/" + slug + "/comments/" + commentId);
  }
};

var FavoriteService = {
  add: function add(slug) {
    return ApiService.post("articles/" + slug + "/favorite");
  },
  remove: function remove(slug) {
    return ApiService.delete("articles/" + slug + "/favorite");
  }
};

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d58f94_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("OSCc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("RB0i")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d58f94_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d58f94_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_date_filter__ = __webpack_require__("GTdA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_error_filter__ = __webpack_require__("hgdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_vue__ = __webpack_require__("e6fC");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import VueStripeCheckout from 'vue-stripe-checkout'
// import { STRIPE_KEY } from '@/common/config'











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', __WEBPACK_IMPORTED_MODULE_6__common_date_filter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('error', __WEBPACK_IMPORTED_MODULE_7__common_error_filter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_bootstrap_vue__["a" /* default */]);

// base/global options
// these options can be overridden
// by the options in the .open(options)
// function.
// const options = {
//   key: STRIPE_KEY,
//   image: 'https://cdn.meme.am/images/100x100/15882140.jpg',
//   locale: 'auto',
//   billingAddress: true,
//   panelLabel: 'Subscribe {{amount}}'
// }
// Vue.use(VueStripeCheckout, STRIPE_KEY);

// Vue.use(VueStripeCheckout, options)

__WEBPACK_IMPORTED_MODULE_5__common_api_service__["a" /* default */].init();

// Ensure we checked auth before each page load.
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  return Promise.all([__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_type__["a" /* CHECK_AUTH */])]).then(next);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OSCc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"banner-body"},[_c('div',{staticClass:"container"},[_c('rwv-header'),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('router-view')],1)]),_vm._v(" "),_c('rwv-footer'),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("© 2015 Quickly. All rights reserved | Design by "),_c('a',{attrs:{"href":"http://w3layouts.com/"}},[_vm._v(" W3layouts")])])]),_vm._v(" "),_c('div',[_c('div',{attrs:{"role":"presentation"}}),_vm._v(" "),_c('a',{staticClass:"accreditation",attrs:{"href":"https://www.a2hosting.com/drupal-hosting?aid=funktechno&bid=d61953ed","target":"_blank","rel":"nofollow","tabindex":"-1"}},[_c('img',{attrs:{"src":"//lh3.googleusercontent.com/proxy/5ED1YUGjFC93154wpBVO4oG6CICKCPA5bASGtPd0MlxuALu5QzSmA5KKO2dU6CZ4RWiLrIDgsc9uHTvpUOBFFIiatheH3C0MmmsHCOGu0jYTkA14DRY=s80-p-k-rw","width":"80","height":"80","alt":""}})])]),_vm._v(" "),_c('div',{attrs:{"role":"presentation"}},[_c('div',[_c('a',{staticClass:"accreditation",attrs:{"href":"https://www.a2hosting.com/drupal-hosting?aid=funktechno&bid=d61953ed","target":"_blank","rel":"nofollow","tabindex":"-1"}},[_c('span',{staticClass:"aaTEdf"},[_vm._v("Drupal Web Hosting | 20X Faster Drupal Hosting")])])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"accreditation",attrs:{"href":"https://www.a2hosting.com/drupal-hosting?aid=funktechno&bid=d61953ed","target":"_blank","rel":"nofollow","tabindex":"-1"}},[_vm._v("a2hosting.com")])]),_vm._v(" "),_c('div',[_vm._v("Drupal Recommended Hosting! Sign Up Today & Get The Fastest Drupal Web Hosting On Market Hosted on High Performance Turbo Servers!")])])])}]


/***/ }),

/***/ "RB0i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RYnZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rd/9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rwvFooter'
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "j7e0"));
    },
    children: [{
      path: '',
      name: 'home',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "Ff+O"));
      }
    }, {
      path: 'my-feed',
      name: 'home-my-feed',
      component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "2Om/"));
      }
    }, {
      path: 'tag/:tag',
      name: 'home-tag',
      component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "kzGc"));
      }
    }]
  }, {
    name: 'login',
    path: '/login',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "lmfZ"));
    }
  }, {
    name: 'register',
    path: '/register',
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "tcoL"));
    }
  }, {
    name: 'about',
    path: '/about',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "vu9I"));
    },
    props: true
  }, {
    name: 'portfolio',
    path: '/portfolio',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "39R+"));
    },
    props: true
  }, {
    name: 'billing',
    path: '/billing',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "6O//"));
    },
    props: true
  }, {
    name: 'confirmation',
    path: '/confirmation/:stripeToken&:card?:stripeEmail?',
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "6O//"));
    },
    props: true
  }, {
    name: 'tos',
    path: '/legal/termsofservice',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "ZTE7"));
    },
    props: true
  }, {
    name: 'privacy',
    path: '/legal/privacy',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "kB2H"));
    },
    props: true
  }, {
    name: 'settings',
    path: '/settings',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "VKKr"));
    }
  },
  // Handle child routes with a default, by giving the name to the
  // child.
  // SO: https://github.com/vuejs/vue-router/issues/777
  {
    path: '/@:username',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "Twgf"));
    },
    children: [{
      path: '',
      name: 'profile',
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "bzRz"));
      }
    }, {
      name: 'profile-favorites',
      path: 'favorites',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "2XD+"));
      }
    }]
  }, {
    name: 'article',
    path: '/articles/:slug',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "UbIS"));
    },
    props: true
  }, {
    name: 'article-edit',
    path: '/editor/:slug?',
    props: true,
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "tFGQ"));
    }
  }]
}));

/***/ }),

/***/ "Zsl5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hG4T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hK/H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hgdF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (errorValue) {
  return "" + errorValue[0];
});

/***/ }),

/***/ "itPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_jwt_service__ = __webpack_require__("5MmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_type__ = __webpack_require__("AezD");
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var state = {
  errors: null,
  user: {},
  isAuthenticated: !!__WEBPACK_IMPORTED_MODULE_1__common_jwt_service__["a" /* default */].getToken()
};

var getters = {
  currentUser: function currentUser(state) {
    return state.user;
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["s" /* LOGIN */], function (context, credentials) {
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].post('users/login', { user: credentials }).then(function (_ref) {
      var data = _ref.data;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], data.user);
      resolve(data);
    }).catch(function (_ref2) {
      var response = _ref2.response;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["i" /* SET_ERROR */], response.data.errors);
    });
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["t" /* LOGOUT */], function (context) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["j" /* PURGE_AUTH */]);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["u" /* REGISTER */], function (context, credentials) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].post('users', { user: credentials }).then(function (_ref3) {
      var data = _ref3.data;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], data.user);
      resolve(data);
    }).catch(function (_ref4) {
      var response = _ref4.response;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["i" /* SET_ERROR */], response.data.errors);
    });
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["a" /* CHECK_AUTH */], function (context) {
  if (__WEBPACK_IMPORTED_MODULE_1__common_jwt_service__["a" /* default */].getToken()) {
    __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].setHeader();
    __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].get('user').then(function (_ref5) {
      var data = _ref5.data;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], data.user);
    }).catch(function (_ref6) {
      var response = _ref6.response;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["i" /* SET_ERROR */], response.data.errors);
    });
  } else {
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["j" /* PURGE_AUTH */]);
  }
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["v" /* UPDATE_USER */], function (context, payload) {
  var email = payload.email,
      username = payload.username,
      password = payload.password,
      image = payload.image,
      bio = payload.bio;

  var user = {
    email: email,
    username: username,
    bio: bio,
    image: image
  };
  if (password) {
    user.password = password;
  }

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].put('user', user).then(function (_ref7) {
    var data = _ref7.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], data.user);
    return data;
  });
}), _actions);

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["i" /* SET_ERROR */], function (state, error) {
  state.errors = error;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], function (state, user) {
  state.isAuthenticated = true;
  state.user = user;
  state.errors = {};
  __WEBPACK_IMPORTED_MODULE_1__common_jwt_service__["a" /* default */].saveToken(state.user.token);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["j" /* PURGE_AUTH */], function (state) {
  state.isAuthenticated = false;
  state.user = {};
  state.errors = {};
  __WEBPACK_IMPORTED_MODULE_1__common_jwt_service__["a" /* default */].destroyToken();
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "lHQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ARTICLE_PUBLISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ARTICLE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ARTICLE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ARTICLE_EDIT_ADD_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ARTICLE_EDIT_REMOVE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ARTICLE_RESET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMMENT_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COMMENT_DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FAVORITE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FAVORITE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_ARTICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_COMMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_PROFILE_FOLLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_PROFILE_UNFOLLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return BILLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHECK_DOMAIN; });
/* unused harmony export CHECK_GROUP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_USER; });
var ARTICLE_PUBLISH = 'publishArticle';
var ARTICLE_DELETE = 'deleteArticle';
var ARTICLE_EDIT = 'editArticle';
var ARTICLE_EDIT_ADD_TAG = 'addTagToArticle';
var ARTICLE_EDIT_REMOVE_TAG = 'removeTagFromArticle';
var ARTICLE_RESET_STATE = 'resetArticleState';
var CHECK_AUTH = 'checkAuth';
var COMMENT_CREATE = 'createComment';
var COMMENT_DESTROY = 'destroyComment';
var FAVORITE_ADD = 'addFavorite';
var FAVORITE_REMOVE = 'removeFavorite';
var FETCH_ARTICLE = 'fetchArticle';
var FETCH_ARTICLES = 'fetchArticles';
var FETCH_COMMENTS = 'fetchComments';
var FETCH_PROFILE = 'fetchProfile';
var FETCH_PROFILE_FOLLOW = 'fetchProfileFollow';
var FETCH_PROFILE_UNFOLLOW = 'fetchProfileUnfollow';
var FETCH_TAGS = 'fetchTags';
var LOGIN = 'login';
var LOGOUT = 'logout';
var REGISTER = 'register';
var BILLING = 'billing';
var CHECK_DOMAIN = 'checkDomain';
var CHECK_GROUP = 'checkGroup';
var UPDATE_USER = 'updateUser';

/***/ }),

/***/ "owOz":
/***/ (function(module, exports) {

// <!-- dependencies -->
// import './responsiveslides.min.js'
// import './jquery.swipebox.min.js'
// import './bootstrap.js'
// import './jquery.flexslider.js'
// import './jquery.chocolat.js'
// import './jquery.hoverdir.js'
// import './modernizr.custom.97074.js'
// import './easyResponsiveTabs.js'

// <!-- directives -->
// import './easyResponsiveTabsDir.js'


/***/ }),

/***/ "uePh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-nav"},[_c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",class:{ collapsed: !_vm.navBar },attrs:{"type":"button","data-toggle":"collapse","data-target":"#bs-example-navbar-collapse-1"},on:{"click":function($event){_vm.navBar = !_vm.navBar}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{ name: 'home' }}},[_vm._v("\n            Group Blogger   \n            ")])],1),_vm._v(" "),_c('div',{staticClass:"navbar-collapse nav-wil",class:[{ collapse: !_vm.navBar }, 'collapse-in'],attrs:{"id":"bs-example-navbar-collapse-1"}},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"hvr-bounce-to-bottom",attrs:{"active-class":"active"}},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'home' }}},[_vm._v("\n                  Home\n                ")])],1),_vm._v(" "),_c('li',{staticClass:"hvr-bounce-to-bottom"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'about' }}},[_vm._v("\n                  About\n                ")])],1),_vm._v(" "),_c('li',{staticClass:"hvr-bounce-to-bottom"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'portfolio' }}},[_vm._v("\n                  Portfolio\n                ")])],1),_vm._v(" "),(_vm.isAuthenticated)?_c('li',{staticClass:"hvr-bounce-to-bottom",class:{ show: _vm.uMenuIsOpen },on:{"click":function($event){_vm.uMenuIsOpen = !_vm.uMenuIsOpen}}},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"target":"_self","id":"navbarDropdownMenuLink","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                                         User Dropdown\n                                  ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",class:{ show: _vm.uMenuIsOpen },attrs:{"aria-labelledby":"navbarDropdownMenuLink"}},[_c('ul',[(_vm.checkGroupRole(_vm.currentUser.usergroups,_vm.mainGroupId,_vm.writerRoles))?_c('li',{staticClass:"hvr-bounce-to-bottom"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","to":{ name: 'article-edit' }}},[_c('i',{staticClass:"ion-compose"}),_vm._v(" New Article\n                      ")])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"hvr-bounce-to-bottom"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'settings' }}},[_c('i',{staticClass:"ion-gear-a"}),_vm._v(" Settings\n                    ")])],1)])])]):_vm._e()]),_vm._v(" "),(!_vm.isAuthenticated)?_c('div',{staticClass:"sign-in"},[_c('ul',[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'login' }}},[_c('i',{staticClass:"ion-compose"}),_vm._v("Sign in\n                ")]),_vm._v(" /\n              ")],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'register' }}},[_c('i',{staticClass:"ion-compose"}),_vm._v("Sign up\n                ")])],1)])]):_c('div',{staticClass:"sign-in"},[_c('ul',[(_vm.currentUser.username)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'profile', params: { username: _vm.currentUser.username } }}},[_vm._v("\n                  "+_vm._s(_vm.currentUser.username)+"\n                ")])],1):_vm._e()])])])])])])}
var staticRenderFns = []


/***/ }),

/***/ "vfl4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wYMm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STRIPE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mainGroupId; });
/* unused harmony default export */ var _unused_webpack_default_export = ({});
var API_URL = "https://api.groupblogger.net/api";
var STRIPE_KEY = "pk_test_APZNs1fORyroy3mkHdO0tI5x";
var mainGroupId = 3;

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheHeader__ = __webpack_require__("BVEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TheFooter__ = __webpack_require__("GyQG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css__ = __webpack_require__("0CPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fonts_font_awesome_4_7_0_css_font_awesome_min_css__ = __webpack_require__("5bni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fonts_font_awesome_4_7_0_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fonts_font_awesome_4_7_0_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dependencies__ = __webpack_require__("owOz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dependencies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dependencies__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// styling


// <!-- fonts -->




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {
    RwvHeader: __WEBPACK_IMPORTED_MODULE_0__components_TheHeader__["a" /* default */],
    RwvFooter: __WEBPACK_IMPORTED_MODULE_1__components_TheFooter__["a" /* default */]
  }
});

/***/ }),

/***/ "zLDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer-grids"},[_c('div',{staticClass:"col-md-6 footer-grid"},[_c('h3',{staticStyle:{"text-align":"center"}},[_c('router-link',{staticClass:"logo-font",attrs:{"to":{ name: 'home', params: {} }}},[_vm._v("\n            Group Blogger\n          ")]),_vm._v("\n            A group managed blog service.\n        ")],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 footer-grid"},[_c('h3',[_vm._v("Support")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{staticClass:"logo-font",attrs:{"to":{ name: 'tos', params: {} }}},[_vm._v("\n              Terms of Service\n            ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacy', params: {} }}},[_vm._v("\n              Privacy Policy\n            ")])],1)])])])])])}
var staticRenderFns = []


/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.73ee47ae3f9d85b26878.js